// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Study
 */
export interface Study {
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    created_by?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    creation_date: string;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    dta_count?: number;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    expected_start_date?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    indication?: string;
    /**
     * 
     * @type {object}
     * @memberof Study
     */
    metadata?: object;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    pending_dta_count?: number;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    study_description?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    study_id: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    study_name: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    study_status: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    therapeutic_area?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    updated_at?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Study
     */
    vendor_ids?: Array<string>;
}

/**
 * Check if a given object implements the Study interface.
 */
export function instanceOfStudy(value: object): value is Study {
    if (!('creation_date' in value) || value['creation_date'] === undefined) return false;
    if (!('study_id' in value) || value['study_id'] === undefined) return false;
    if (!('study_name' in value) || value['study_name'] === undefined) return false;
    if (!('study_status' in value) || value['study_status'] === undefined) return false;
    return true;
}

export function StudyFromJSON(json: any): Study {
    return StudyFromJSONTyped(json, false);
}

export function StudyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Study {
    if (json == null) {
        return json;
    }
    return {
        
        'created_by': json['created_by'] == null ? undefined : json['created_by'],
        'creation_date': json['creation_date'],
        'dta_count': json['dta_count'] == null ? undefined : json['dta_count'],
        'expected_start_date': json['expected_start_date'] == null ? undefined : json['expected_start_date'],
        'indication': json['indication'] == null ? undefined : json['indication'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'pending_dta_count': json['pending_dta_count'] == null ? undefined : json['pending_dta_count'],
        'study_description': json['study_description'] == null ? undefined : json['study_description'],
        'study_id': json['study_id'],
        'study_name': json['study_name'],
        'study_status': json['study_status'],
        'therapeutic_area': json['therapeutic_area'] == null ? undefined : json['therapeutic_area'],
        'updated_at': json['updated_at'] == null ? undefined : json['updated_at'],
        'vendor_ids': json['vendor_ids'] == null ? undefined : json['vendor_ids'],
    };
}

export function StudyToJSON(json: any): Study {
    return StudyToJSONTyped(json, false);
}

export function StudyToJSONTyped(value?: Study | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_by': value['created_by'],
        'creation_date': value['creation_date'],
        'dta_count': value['dta_count'],
        'expected_start_date': value['expected_start_date'],
        'indication': value['indication'],
        'metadata': value['metadata'],
        'pending_dta_count': value['pending_dta_count'],
        'study_description': value['study_description'],
        'study_id': value['study_id'],
        'study_name': value['study_name'],
        'study_status': value['study_status'],
        'therapeutic_area': value['therapeutic_area'],
        'updated_at': value['updated_at'],
        'vendor_ids': value['vendor_ids'],
    };
}
